import { render, staticRenderFns } from "./save-configurations-modal.vue?vue&type=template&id=4b497ddc&scoped=true&"
import script from "./save-configurations-modal.vue?vue&type=script&lang=tsx&"
export * from "./save-configurations-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./save-configurations-modal.vue?vue&type=style&index=0&id=4b497ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b497ddc",
  null
  
)

export default component.exports